export const formatTimer = (value: number) => (value < 10 ? `0${value}` : value)
